async function fetchInBatches(items, batchSize) {
  for (let i = 0; i < items.length; i += batchSize) {
    const batch = items.slice(i, i + batchSize);

    // Process this batch concurrently
    await Promise.all(
      batch.map(async (item) => {
        try {
          if (!document.querySelector(`[data-product-id="${item.id}"]`)) return;
          const response = await fetch(
            `/products/${item.handle}?sections=product-thumbnail`
          );
          console.log("fetching", item);
          const data = await response.json();
          document.querySelector(`[data-product-id="${item.id}"]`).innerHTML =
            data["product-thumbnail"];
        } catch (error) {
          console.error(`Error fetching ${item.handle}:`, error);
        }
      })
    );
  }
}

function afterGetFilterApi(context, data) {
  // delay for 1 second
  setTimeout(async () => {
    const selectors = {
      card: ".boost-sd__product-item",
    };

    const productCards = document.querySelectorAll(selectors.card);

    const cards = Array.from(productCards).map((card) => {
      return {
        id: card.dataset.productId,
        handle: JSON.parse(card.dataset.product).handle,
      };
    });

    fetchInBatches(cards, 4);
  }, 200);
}

// boostWidgetIntegration.regisCustomization(afterGetFilterApi);
